'use es6';

import { getProducts, getPublicProducts } from '../api/ProductsApi';
import makeFetchRequest from './makeFetchRequest';
import { createRequestTypes, createRequestActions } from './RequestActions';
export const FetchProductsRequestTypes = createRequestTypes('PRODUCTS');
export const FetchProductsActions = createRequestActions(FetchProductsRequestTypes);
export const fetchProducts = () => dispatch => {
  return makeFetchRequest({
    requestActions: FetchProductsActions,
    fetch: getProducts
  })(dispatch);
};
export const fetchPublicProducts = () => dispatch => {
  return makeFetchRequest({
    requestActions: FetchProductsActions,
    fetch: getPublicProducts
  })(dispatch);
};